var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"bcx-all bcx-main-content bc-content-area",class:{'bc-content-area--padding':!_vm.noPadding}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }